import { render, staticRenderFns } from "./riepilogoOre.html?vue&type=template&id=32caac76&scoped=true&"
import script from "./RiepilogoOre.vue?vue&type=script&lang=js&"
export * from "./RiepilogoOre.vue?vue&type=script&lang=js&"
import style0 from "./RiepilogoOre.vue?vue&type=style&index=0&id=32caac76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32caac76",
  null
  
)

export default component.exports